import { render } from "./AddView.vue?vue&type=template&id=9254ba4a&scoped=true"
import script from "./AddView.vue?vue&type=script&lang=js"
export * from "./AddView.vue?vue&type=script&lang=js"

import "./AddView.vue?vue&type=style&index=0&id=9254ba4a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9254ba4a"]])

export default __exports__